const TAPANDA_GIFT_WRAP_PENDING_KEY = 'tapanda-gift-wrap-pending-variant-id';
const TAPANDA_CART_REDIRECT_GUARD_UNTIL_KEY = 'tapanda-cart-redirect-guard-until';
const TAPANDA_CART_REDIRECT_ALLOW_UNTIL_KEY = 'tapanda-cart-redirect-allow-until';
const TAPANDA_CART_REDIRECT_RETURN_URL_KEY = 'tapanda-cart-redirect-return-url';
const TAPANDA_CART_PROMO_OPEN_UNTIL_KEY = 'tapanda-cart-promo-open-until';
const TAPANDA_CART_REDIRECT_GUARD_DURATION_MS = 5000;
const TAPANDA_CART_REDIRECT_GUARD_MAX_MS = 5000;
const TAPANDA_CREATOR_SCOPE_SELECTOR = 'product-form, .tee-customize-main-form, form.tee-form-wrapper, #teeinblue-wrapper, [data-teeinblue], [id^="MainProduct-"]';
const TAPANDA_CREATOR_ACTION_SELECTOR = '.tp-guided-step-toggle, #teeAtcButton, .tee-btn--atc, #teeFormActions button, .tee-form-actions button, .product-form__submit, [name="add"], [data-tp-next-step], [data-next-step]';
const tapandaComposingTextControls = new WeakSet();
const tapandaTrimDispatchingControls = new WeakSet();

function tapandaTrimEnd(value) {
  return typeof value === 'string' ? value.trimEnd() : value;
}

function tapandaIsLineItemPropertyControl(control) {
  return !!(
    control &&
    typeof control.name === 'string' &&
    control.name.indexOf('properties[') === 0
  );
}

function tapandaIsFrontendTextControl(control) {
  if (!control || !control.tagName) return false;
  const tagName = String(control.tagName).toLowerCase();
  if (tagName === 'textarea') return true;
  if (tagName !== 'input') return false;
  const inputType = String(control.type || 'text').toLowerCase();
  return inputType === 'text' || inputType === 'search' || inputType === 'email' || inputType === 'tel' || inputType === 'url';
}

function tapandaIsCreatorTextControl(control) {
  if (!control || !control.closest) return false;
  const isHiddenLineItemProperty = !!(
    tapandaIsLineItemPropertyControl(control) &&
    String(control.tagName || '').toLowerCase() === 'input' &&
    String(control.type || '').toLowerCase() === 'hidden'
  );
  if (!tapandaIsFrontendTextControl(control) && !isHiddenLineItemProperty) return false;
  return tapandaIsLineItemPropertyControl(control) || !!control.closest(TAPANDA_CREATOR_SCOPE_SELECTOR);
}

function tapandaSetTextControlValue(control, value) {
  const prototype = control.tagName && String(control.tagName).toLowerCase() === 'textarea'
    ? window.HTMLTextAreaElement && window.HTMLTextAreaElement.prototype
    : window.HTMLInputElement && window.HTMLInputElement.prototype;
  const descriptor = prototype && Object.getOwnPropertyDescriptor(prototype, 'value');
  if (descriptor && typeof descriptor.set === 'function') {
    descriptor.set.call(control, value);
    return;
  }
  control.value = value;
}

function tapandaDispatchTrimEvents(control) {
  if (!tapandaIsFrontendTextControl(control) || tapandaTrimDispatchingControls.has(control)) return;
  tapandaTrimDispatchingControls.add(control);
  try {
    control.dispatchEvent(new Event('input', { bubbles: true }));
    control.dispatchEvent(new Event('change', { bubbles: true }));
  } finally {
    tapandaTrimDispatchingControls.delete(control);
  }
}

function tapandaTrimTextControl(control, dispatchEvents = true) {
  if (!tapandaIsCreatorTextControl(control) || tapandaComposingTextControls.has(control)) return false;
  const currentValue = typeof control.value === 'string' ? control.value : '';
  const trimmedValue = tapandaTrimEnd(currentValue);
  if (trimmedValue === currentValue) return false;
  tapandaSetTextControlValue(control, trimmedValue);
  if (dispatchEvents) tapandaDispatchTrimEvents(control);
  return true;
}

function tapandaTrimCreatorTextFields(scopeNode) {
  if (!scopeNode) return 0;
  const controls = [];
  if (scopeNode.matches && scopeNode.matches('input, textarea')) controls.push(scopeNode);
  if (scopeNode.querySelectorAll) {
    scopeNode.querySelectorAll('input, textarea').forEach((control) => controls.push(control));
  }
  return controls.reduce((count, control) => count + (tapandaTrimTextControl(control, true) ? 1 : 0), 0);
}

function tapandaTrimLineItemProperties(formData) {
  if (!formData || typeof formData.entries !== 'function') return formData;
  Array.from(formData.entries()).forEach(([key, value]) => {
    if (typeof key !== 'string' || key.indexOf('properties[') !== 0 || typeof value !== 'string') return;
    const trimmedValue = tapandaTrimEnd(value);
    if (trimmedValue !== value) formData.set(key, trimmedValue);
  });
  return formData;
}

function tapandaInitCreatorTextTrimming() {
  if (window.__tapandaCreatorTextTrimmingReady) return;
  window.__tapandaCreatorTextTrimmingReady = true;
  window.tapandaTrimCreatorTextFields = tapandaTrimCreatorTextFields;
  window.tapandaTrimLineItemProperties = tapandaTrimLineItemProperties;

  document.addEventListener('compositionstart', (event) => {
    if (tapandaIsCreatorTextControl(event.target)) tapandaComposingTextControls.add(event.target);
  }, true);

  document.addEventListener('compositionend', (event) => {
    if (event.target) tapandaComposingTextControls.delete(event.target);
  }, true);

  document.addEventListener('blur', (event) => {
    tapandaTrimTextControl(event.target, true);
  }, true);

  document.addEventListener('click', (event) => {
    const actionNode = event.target && event.target.closest ? event.target.closest(TAPANDA_CREATOR_ACTION_SELECTOR) : null;
    if (!actionNode) return;
    const scopeNode = actionNode.closest('form') || actionNode.closest(TAPANDA_CREATOR_SCOPE_SELECTOR);
    if (scopeNode) tapandaTrimCreatorTextFields(scopeNode);
  }, true);

  document.addEventListener('submit', (event) => {
    const formNode = event.target;
    if (!formNode || !formNode.querySelector) return;
    if (!formNode.matches(TAPANDA_CREATOR_SCOPE_SELECTOR) && !formNode.closest(TAPANDA_CREATOR_SCOPE_SELECTOR) && !formNode.querySelector('[name^="properties["]')) return;
    tapandaTrimCreatorTextFields(formNode);
  }, true);

  document.addEventListener('formdata', (event) => {
    tapandaTrimLineItemProperties(event.formData);
  });
}

tapandaInitCreatorTextTrimming();

function tapandaRememberGiftWrapIntent(variantId) {
  const normalizedVariantId = String(variantId || '').trim();
  if (!normalizedVariantId) return;

  try {
    sessionStorage.setItem(TAPANDA_GIFT_WRAP_PENDING_KEY, normalizedVariantId);
  } catch (_error) {
    // no-op
  }
}

function tapandaReadGiftWrapIntent() {
  try {
    return String(sessionStorage.getItem(TAPANDA_GIFT_WRAP_PENDING_KEY) || '').trim();
  } catch (_error) {
    return '';
  }
}

function tapandaClearGiftWrapIntent(variantId) {
  try {
    const pendingVariantId = tapandaReadGiftWrapIntent();
    if (!pendingVariantId) return;
    if (variantId && String(variantId).trim() !== pendingVariantId) return;
    sessionStorage.removeItem(TAPANDA_GIFT_WRAP_PENDING_KEY);
  } catch (_error) {
    // no-op
  }
}

function tapandaFindSelectedGiftWrapToggle(scopeNode) {
  const rootsToScan = [];
  if (scopeNode && scopeNode.querySelectorAll) rootsToScan.push(scopeNode);
  if (scopeNode && scopeNode.closest) {
    const productRoot = scopeNode.closest('[id^="MainProduct-"], .main-product-template, .product');
    if (productRoot && !rootsToScan.includes(productRoot)) {
      rootsToScan.push(productRoot);
    }
  }
  rootsToScan.push(document);

  for (let i = 0; i < rootsToScan.length; i += 1) {
    const root = rootsToScan[i];
    if (!root || !root.querySelectorAll) continue;
    const toggles = root.querySelectorAll('[data-tp-gift-wrap-toggle][data-gift-variant-id]');
    if (!toggles || !toggles.length) continue;

    const checkedToggle = Array.from(toggles).find((node) => node && node.checked && !node.disabled);
    if (checkedToggle) return checkedToggle;
  }

  return null;
}

function tapandaReadSessionNumber(keyName) {
  try {
    return Number(sessionStorage.getItem(keyName) || 0);
  } catch (_error) {
    return 0;
  }
}

function tapandaWriteSessionNumber(keyName, value) {
  try {
    sessionStorage.setItem(keyName, String(Math.max(0, Number(value) || 0)));
  } catch (_error) {
    // no-op
  }
}

function tapandaRememberCartReturnUrl() {
  try {
    const url = `${window.location.pathname || '/'}${window.location.search || ''}`;
    sessionStorage.setItem(TAPANDA_CART_REDIRECT_RETURN_URL_KEY, url);
  } catch (_error) {
    // no-op
  }
}

function tapandaToFiniteNumber(value, fallback = 0) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
}

function tapandaResolveCurrencyCode(preferredCurrency) {
  const currencyFromArgs = String(preferredCurrency || '').trim();
  if (currencyFromArgs) return currencyFromArgs.toUpperCase();

  const shopifyCurrency = window.Shopify && window.Shopify.currency;
  const activeCurrency = shopifyCurrency && String(shopifyCurrency.active || '').trim();
  if (activeCurrency) return activeCurrency.toUpperCase();

  const isoCurrency = shopifyCurrency && String(shopifyCurrency.iso_code || '').trim();
  if (isoCurrency) return isoCurrency.toUpperCase();

  return '';
}

function tapandaBuildAddToCartItem(addResponse, quantityOverride) {
  if (!addResponse || typeof addResponse !== 'object') return null;

  const quantityCandidate = quantityOverride != null ? quantityOverride : addResponse.quantity;
  const quantity = Math.max(1, tapandaToFiniteNumber(quantityCandidate, 1));

  const productId = String(addResponse.product_id || addResponse.id || '').trim();
  const productTitle = String(addResponse.product_title || addResponse.title || '').trim();
  if (!productId && !productTitle) return null;

  const itemPayload = {
    item_id: productId || productTitle,
    item_name: productTitle || productId,
    quantity
  };

  const variantTitle = String(addResponse.variant_title || '').trim();
  if (variantTitle && variantTitle.toLowerCase() !== 'default title') {
    itemPayload.item_variant = variantTitle;
  }

  const variantId = String(addResponse.variant_id || addResponse.id || '').trim();
  if (variantId) {
    itemPayload.item_variant_id = variantId;
  }

  const vendor = String(addResponse.vendor || '').trim();
  if (vendor) {
    itemPayload.item_brand = vendor;
  }

  const productType = String(addResponse.product_type || '').trim();
  if (productType) {
    itemPayload.item_category = productType;
  }

  const sku = String(addResponse.sku || '').trim();
  if (sku) {
    itemPayload.item_sku = sku;
  }

  const itemPriceCents = tapandaToFiniteNumber(addResponse.final_price, NaN);
  const fallbackPriceCents = tapandaToFiniteNumber(addResponse.price, NaN);
  const resolvedPriceCents = Number.isFinite(itemPriceCents) ? itemPriceCents : fallbackPriceCents;
  if (Number.isFinite(resolvedPriceCents) && resolvedPriceCents > 0) {
    itemPayload.price = Number((resolvedPriceCents / 100).toFixed(2));
  }

  return itemPayload;
}

function tapandaTrackAddToCartEvent(addResponse, options = {}) {
  if (typeof window.tapandaTrack !== 'function') return;
  if (!addResponse || addResponse.status) return;

  const itemPayload = tapandaBuildAddToCartItem(addResponse, options.quantity);
  if (!itemPayload) return;

  const price = tapandaToFiniteNumber(itemPayload.price, 0);
  const quantity = tapandaToFiniteNumber(itemPayload.quantity, 1);
  const ecommercePayload = {
    value: Number((price * quantity).toFixed(2)),
    items: [itemPayload]
  };

  const currencyCode = tapandaResolveCurrencyCode(options.currency || addResponse.currency);
  if (currencyCode) {
    ecommercePayload.currency = currencyCode;
  }

  const eventDetail = {
    ecommerce: ecommercePayload,
    tapanda_source: String(options.source || 'product_form').trim() || 'product_form'
  };

  if (options.giftWrapIncluded === true) {
    eventDetail.tapanda_gift_wrap_included = true;
  }

  window.tapandaTrack('add_to_cart', eventDetail, { category: 'analytics' });
}

function tapandaIsCartGuardActive() {
  return Date.now() <= Number(window.__tpBlockCartNavigationUntil || 0);
}

function tapandaIsPromoPopupOpen() {
  return !!(document.body && document.body.classList && document.body.classList.contains('tp-cart-promo-open'));
}

function tapandaCanNavigateToCart() {
  const now = Date.now();
  const allowUntil = tapandaReadSessionNumber(TAPANDA_CART_REDIRECT_ALLOW_UNTIL_KEY);
  const promoPopupOpenUntil = tapandaReadSessionNumber(TAPANDA_CART_PROMO_OPEN_UNTIL_KEY);
  if (now <= promoPopupOpenUntil && now > allowUntil) {
    return false;
  }
  if (tapandaIsPromoPopupOpen()) {
    return now <= allowUntil;
  }
  if (!tapandaIsCartGuardActive()) return true;
  return now <= allowUntil;
}

function tapandaAllowCartNavigation(durationMs = 30000) {
  const allowUntil = Date.now() + (Number(durationMs) || 30000);
  tapandaWriteSessionNumber(TAPANDA_CART_REDIRECT_ALLOW_UNTIL_KEY, allowUntil);
  tapandaWriteSessionNumber(TAPANDA_CART_PROMO_OPEN_UNTIL_KEY, 0);
}

function tapandaNavigateToCart(reason = 'gift_wrap') {
  tapandaWriteSessionNumber(TAPANDA_CART_PROMO_OPEN_UNTIL_KEY, 0);
  tapandaAllowCartNavigation(45000);
  try {
    window.tapandaTrack && window.tapandaTrack('tapanda_cart_redirect', {
      tapanda_source: 'product_form',
      tapanda_reason: String(reason || 'gift_wrap')
    }, { category: 'analytics' });
  } catch (_error) {
    // no-op
  }
  window.location.assign((window.routes && window.routes.cart_url) || '/cart');
}

function tapandaHydrateCartRedirectGuard() {
  const guardUntil = Math.max(
    tapandaReadSessionNumber(TAPANDA_CART_REDIRECT_GUARD_UNTIL_KEY),
    tapandaReadSessionNumber(TAPANDA_CART_PROMO_OPEN_UNTIL_KEY)
  );
  if (guardUntil > Date.now()) {
    window.__tpBlockCartNavigationUntil = guardUntil;
  }
}

function tapandaRecoverFromUnexpectedCartRedirect() {
  if (typeof window === 'undefined') return;
  const guardUntil = Math.max(
    Number(window.__tpBlockCartNavigationUntil || 0),
    tapandaReadSessionNumber(TAPANDA_CART_PROMO_OPEN_UNTIL_KEY)
  );
  if (Date.now() > guardUntil) return;
  if (tapandaCanNavigateToCart()) return;
  if (!tapandaIsCartUrl(window.location.href || window.location.pathname || '')) return;

  let fallbackUrl = '/';
  try {
    fallbackUrl = sessionStorage.getItem(TAPANDA_CART_REDIRECT_RETURN_URL_KEY) || '/';
  } catch (_error) {
    fallbackUrl = '/';
  }

  if (!fallbackUrl || tapandaIsCartUrl(fallbackUrl)) {
    fallbackUrl = '/';
  }

  try {
    window.location.replace(fallbackUrl);
  } catch (_error) {
    // no-op
  }
}

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');         
      if(!this.form) return;
      const variantInput = this.form.querySelector('[name=id]');
      if (variantInput) variantInput.disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (this.submitButton && document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.hideErrors = this.dataset.hideErrors === 'true';
      this.skipPromoPopup = this.dataset.tpSkipPromoPopup === 'true';
    }

    isTeeinblueManagedSubmit(evt) {
      const submitter = evt && (evt.submitter || document.activeElement);
      if (submitter && submitter.closest && submitter.closest('#teeFormActions, .tee-form-actions')) return true;
      if (submitter && (submitter.id === 'teeAtcButton' || (submitter.classList && submitter.classList.contains('tee-btn--atc')))) return true;

      const productScope = this.closest('[id^="MainProduct-"], .main-product-template, .product') || document;
      if (
        productScope &&
        productScope.querySelector &&
        productScope.querySelector('#teeAtcButton, .tee-btn--atc, #teeFormActions, .tee-form-actions, .tee-customize-main-form, [data-teeinblue], [class*="teeinblue"]')
      ) {
        return true;
      }

      if (
        document.body &&
        document.body.classList &&
        document.body.classList.contains('teeinblue-enabled') &&
        document.querySelector('#teeAtcButton, .tee-btn--atc, #teeFormActions, .tee-form-actions, .tee-customize-main-form, [data-teeinblue], [class*="teeinblue"]')
      ) {
        return true;
      }

      if (!this.form || !this.form.querySelector) return false;
      if (this.form.matches && this.form.matches('.tee-customize-main-form, form.tee-form-wrapper')) return true;

      return !!this.form.querySelector(
        '#teeAtcButton, .tee-btn--atc, #teeFormActions, .tee-form-actions, .tee-customize-main-form, .tee-preview-wrapper, [data-teeinblue], [class*="teeinblue"], [name^="properties[_tee"], [name*="teeinblue"]'
      );
    }

    getProductScope() {
      return this.closest('[id^="MainProduct-"], .main-product-template, .product') || document;
    }

    getTeeinblueAtcButton() {
      const productScope = this.getProductScope();
      if (!productScope || !productScope.querySelector) return null;
      const selector = '#teeAtcButton, .tee-btn--atc, #teeFormActions button[type="submit"], .tee-form-actions button[type="submit"]';
      const candidates = Array.from(productScope.querySelectorAll(selector));
      if (!candidates.length) return null;

      const visibleCandidate = candidates.find((node) => {
        if (!node) return false;
        if (node.disabled) return false;
        if (node.offsetParent !== null) return true;
        const style = window.getComputedStyle(node);
        return style && style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
      });

      return visibleCandidate || candidates[0] || null;
    }

    isNativeThemeAtcSubmitter(submitter) {
      if (!submitter) return false;
      if (submitter.classList && submitter.classList.contains('product-form__submit')) return true;
      if (String(submitter.name || '').toLowerCase() === 'add') return true;
      const submitterId = String(submitter.id || '').toLowerCase();
      if (submitterId === 'product-form__submit') return true;
      return false;
    }

    _scheduleTeeinbluePopup() {
      // Poll for cart change, then show promo popup.
      // Teeinblue AJAX typically completes in 1-3 seconds.
      let attempts = 0;
      const maxAttempts = 15;
      const pollInterval = 500;
      let initialCartCount = -1;

      // Get initial cart item count
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(r => r.json())
        .then(data => { initialCartCount = data.item_count || 0; })
        .catch(() => { initialCartCount = 0; });

      const pollTimer = setInterval(() => {
        attempts++;
        if (attempts >= maxAttempts) {
          clearInterval(pollTimer);
          // Fallback: show popup anyway after max wait
          if (typeof showCartPromotionPopup === 'function') {
            showCartPromotionPopup();
          }
          return;
        }

        fetch('/cart.js', { credentials: 'same-origin' })
          .then(r => r.json())
          .then(data => {
            const currentCount = data.item_count || 0;
            if (initialCartCount >= 0 && currentCount > initialCartCount) {
              clearInterval(pollTimer);
              // Product was added! Show the popup.
              if (typeof showCartPromotionPopup === 'function') {
                showCartPromotionPopup();
              }
            }
          })
          .catch(() => {});
      }, pollInterval);
    }

    onSubmitHandler(evt) {
      tapandaTrimCreatorTextFields(this.form);
      if (this.isTeeinblueManagedSubmit(evt)) {
        const teeGiftWrapToggle = tapandaFindSelectedGiftWrapToggle(this.form || document);
        const teeGiftWrapVariantId = teeGiftWrapToggle && teeGiftWrapToggle.checked
          ? String(teeGiftWrapToggle.dataset.giftVariantId || '').trim()
          : '';
        if (teeGiftWrapVariantId) {
          tapandaRememberGiftWrapIntent(teeGiftWrapVariantId);
        } else {
          tapandaClearGiftWrapIntent();
        }

        // Block native form POST — Teeinblue uses AJAX (/cart/add.js) and
        // handles its own redirect to /cart with personalization data.
        evt.preventDefault();
        evt.stopImmediatePropagation();

        // Clear any active cart redirect guard so Teeinblue can navigate to /cart
        tapandaWriteSessionNumber(TAPANDA_CART_REDIRECT_GUARD_UNTIL_KEY, 0);
        tapandaWriteSessionNumber(TAPANDA_CART_PROMO_OPEN_UNTIL_KEY, 0);
        window.__tpBlockCartNavigationUntil = 0;
        tapandaAllowCartNavigation(45000);

        // If the native theme ATC button was clicked, redirect to Teeinblue's button
        const submitter = evt && (evt.submitter || document.activeElement);
        if (this.isNativeThemeAtcSubmitter(submitter)) {
          const teeinblueAtcButton = this.getTeeinblueAtcButton();
          if (teeinblueAtcButton && teeinblueAtcButton !== submitter) {
            teeinblueAtcButton.click();
            return;
          }
          if (!teeinblueAtcButton) {
            this.handleErrorMessage('Poczekaj chwilę — personalizator produktu jeszcze się ładuje.');
            return;
          }
        }

        // Teeinblue's own button was clicked
        if (!this.skipPromoPopup) {
          this._scheduleTeeinbluePopup();
        }
        return;
      }

      evt.preventDefault();
      if (this.submitButton && this.submitButton.getAttribute('aria-disabled') === 'true') return;
      tapandaActivateCartRedirectGuard(TAPANDA_CART_REDIRECT_GUARD_DURATION_MS);

      // --- BEGIN TAPANDA VALIDATION ---
      if (this.form.querySelector('.tp-guided-step') && !this.form.classList.contains('tp-guided-form-complete')) {
        const firstPendingStep = this.form.querySelector('.tp-guided-step.is-pending-step');
        if (firstPendingStep) {
          firstPendingStep.classList.add('tp-validation-error-glow');
          setTimeout(() => firstPendingStep.classList.remove('tp-validation-error-glow'), 4000);
          
          let stepName = 'wymagane pola';
          const titleEl = firstPendingStep.querySelector('.tee-title') || firstPendingStep.querySelector('h2, h3, h4');
          if (titleEl) stepName = titleEl.textContent.replace('Krok ', '').trim();
          
          this.handleErrorMessage(`Proszę uzupełnić: ${stepName}, aby dodać do koszyka.`);
          
          const toggleBtn = firstPendingStep.querySelector('.tp-guided-step-toggle');
          if (toggleBtn && firstPendingStep.getAttribute('aria-expanded') !== 'true') {
            toggleBtn.click();
          }
          firstPendingStep.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
      }
      // --- END TAPANDA VALIDATION ---

      this.handleErrorMessage();

      if (this.submitButton) {
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
      }
      const loadingSpinner = this.querySelector('.loading-overlay__spinner');
      if (loadingSpinner) loadingSpinner.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = tapandaTrimLineItemProperties(new FormData(this.form));
      
       if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

      
      config.body = formData;
    

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then(async (response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton ? this.submitButton.querySelector('.sold-out-message') : null;
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            const submitLabel = this.submitButton.querySelector('span');
            if (submitLabel) submitLabel.classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          this.error = false;
          let cartResponse = response;

          const giftWrapToggle = tapandaFindSelectedGiftWrapToggle(this.form);
          const shouldAddGiftWrap = !!(
            giftWrapToggle &&
            giftWrapToggle.checked &&
            giftWrapToggle.dataset.giftVariantId
          );
          const giftWrapVariantId = shouldAddGiftWrap
            ? String(giftWrapToggle.dataset.giftVariantId || '').trim()
            : '';

          tapandaTrackAddToCartEvent(response, {
            source: 'pdp_primary_product',
            giftWrapIncluded: shouldAddGiftWrap
          });

          if (giftWrapVariantId) {
            tapandaRememberGiftWrapIntent(giftWrapVariantId);
          } else {
            tapandaClearGiftWrapIntent();
          }

          let giftWrapAdded = false;
          if (giftWrapVariantId) {
            const giftWrapResponse = await addGiftWrapVariantToCart(
              giftWrapVariantId,
              this.cart,
              { source: 'pdp_gift_wrap_toggle' }
            );
            if (giftWrapResponse && !giftWrapResponse.status) {
              cartResponse = giftWrapResponse;
              giftWrapAdded = true;
            }
          }

          if (giftWrapVariantId && giftWrapAdded) {
            tapandaNavigateToCart('pdp_gift_wrap_toggle');
            return;
          }

          applySecondProductDiscountCode({ force: true });

          if (!this.cart) {
            if (!this.skipPromoPopup) {
              tapandaSuppressExternalAtcNotice();
              showCartPromotionPopup({ giftWrapSelected: shouldAddGiftWrap });
            }
            return;
          }

          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => {
                this.cart.renderContents(cartResponse);
                if (!this.skipPromoPopup) {
                  tapandaSuppressExternalAtcNotice();
                  showCartPromotionPopup({ giftWrapSelected: shouldAddGiftWrap });
                }
              });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(cartResponse);
            if (!this.skipPromoPopup) {
              tapandaSuppressExternalAtcNotice();
              showCartPromotionPopup({ giftWrapSelected: shouldAddGiftWrap });
            }
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          if (this.submitButton) this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error && this.submitButton) this.submitButton.removeAttribute('aria-disabled');
          if (loadingSpinner) loadingSpinner.classList.add('hidden');
           setTimeout(function(){
            if (typeof giftCart === 'function') {
         	    giftCart();
            }
          }, 1000); 
        });
    }

    handleErrorMessage(errorMessage = false) {
       if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

function addGiftWrapVariantToCart(variantId, cart, options = {}) {
  if (!variantId) return Promise.resolve(null);

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', '1');

  if (cart) {
    formData.append(
      'sections',
      cart.getSectionsToRender().map((section) => section.id)
    );
    formData.append('sections_url', window.location.pathname);
  }

  config.body = formData;

  return fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((responseData) => {
      if (responseData && !responseData.status) {
        tapandaClearGiftWrapIntent(variantId);
        if (options.skipTracking !== true) {
          tapandaTrackAddToCartEvent(responseData, {
            source: options.source || 'gift_wrap'
          });
        }
      }
      return responseData;
    })
    .catch(() => null);
}


function giftCart() {
  const cartItems = document.querySelectorAll('tr.cart-item');
    cartItems.forEach(cartItem => {        
        const dataId = cartItem.getAttribute('data-id');
        const drawerFooter = document.querySelector(`#Gift-Wrapper[data-id="${dataId}"]`);  
      if(!drawerFooter) return;
      const drawerFooterID = drawerFooter.getAttribute('data-id');
        if(drawerFooterID == dataId) {            
            drawerFooter.classList.add('Gift-Wrapper__hide'); 
        }
    });
}

function tapandaGetCartUiElement() {
  return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
}

function tapandaSuppressExternalAtcNotice() {
  const muteCartLink = (linkNode) => {
    if (!linkNode || !linkNode.getAttribute) return;
    if (linkNode.dataset && !linkNode.dataset.tpOriginalHref) {
      const currentHref = linkNode.getAttribute('href') || '';
      if (currentHref) {
        linkNode.dataset.tpOriginalHref = currentHref;
      }
    }
    linkNode.setAttribute('href', '#');
    linkNode.setAttribute('aria-hidden', 'true');
    linkNode.tabIndex = -1;
    linkNode.classList.add('tp-tee-atc-success__link-muted');
  };

  const cartNotification = document.querySelector('cart-notification');
  if (cartNotification && typeof cartNotification.close === 'function') {
    try {
      cartNotification.close();
    } catch (_error) {
      // no-op
    }
  }

  const notificationPanel = document.getElementById('cart-notification');
  if (notificationPanel) {
    notificationPanel.classList.remove('active');
  }

  document.querySelectorAll('.tp-tee-atc-success').forEach((noticeNode) => {
    noticeNode.classList.add('tp-tee-atc-success--hidden');
  });

  const normalizeStatusText = (value) => String(value || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .trim();

  const isAtcStatusText = (value) => (
    value.indexOf('dodano do koszyka') !== -1 ||
    value.indexOf('ten przedmiot zostal dodany') !== -1 ||
    value.indexOf('added to cart') !== -1
  );

  document.querySelectorAll('#teeFormActions, .tee-form-actions, .tee-form-responses').forEach((actionsNode) => {
    actionsNode.querySelectorAll('a[href*="/cart"], a[href*="cart"], .tee-success').forEach((linkNode) => {
      muteCartLink(linkNode);
      let holderNode = linkNode;
      while (holderNode && holderNode !== actionsNode) {
        const nodeText = normalizeStatusText(holderNode.textContent || '');
        if (isAtcStatusText(nodeText) || holderNode.classList.contains('tee-success')) {
          holderNode.classList.add('tp-tee-atc-success--hidden');
          break;
        }
        holderNode = holderNode.parentElement;
      }
    });
  });

  document.querySelectorAll('.tp-tee-atc-success a[href*="/cart"], .tp-tee-atc-success a[href*="cart"]').forEach((linkNode) => {
    muteCartLink(linkNode);
  });
}

function tapandaEscapeHtml(value) {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function tapandaGetGiftWrapOffer() {
  const rawOffer = window.tapandaGiftWrapOffer || null;
  if (!rawOffer || !rawOffer.variantId) return null;

  return {
    variantId: String(rawOffer.variantId),
    title: String(rawOffer.title || 'Opakowanie prezentowe'),
    price: String(rawOffer.price || ''),
    description: String(rawOffer.description || ''),
    image: String(rawOffer.image || ''),
    url: String(rawOffer.url || '')
  };
}

function tapandaSetPopupGiftWrapState(isInCart) {
  const popup = document.getElementById('tp-cart-promo-popup');
  if (!popup) return;

  const addButton = popup.querySelector('[data-tp-popup-add-gift-wrap]');
  const noteNode = popup.querySelector('[data-tp-popup-gift-wrap-note]');
  const addonsNode = popup.querySelector('.tp-cart-promo-popup__addons');
  if (!addButton || !noteNode) return;

  popup.classList.toggle('tp-cart-promo-popup--gift-wrap-in-cart', !!isInCart);
  if (addonsNode) {
    addonsNode.hidden = !!isInCart;
    addonsNode.classList.toggle('is-hidden', !!isInCart);
  }

  if (isInCart) {
    addButton.hidden = true;
    addButton.classList.add('is-hidden');
    addButton.setAttribute('aria-hidden', 'true');
    noteNode.hidden = false;
    noteNode.classList.remove('is-hidden');
    return;
  }

  addButton.hidden = false;
  addButton.classList.remove('is-hidden');
  addButton.setAttribute('aria-hidden', 'false');
  addButton.disabled = false;
  addButton.textContent = 'Dodaj opakowanie prezentowe';
  noteNode.hidden = true;
  noteNode.classList.add('is-hidden');
}

function tapandaCheckGiftWrapInCart(variantId) {
  if (!variantId) return Promise.resolve(false);

  return fetch('/cart.js', { credentials: 'same-origin' })
    .then((response) => {
      if (!response || !response.ok) return null;
      return response.json();
    })
    .then((cartData) => {
      if (!cartData || !Array.isArray(cartData.items)) return false;
      return cartData.items.some((item) => String(item.id) === String(variantId));
    })
    .catch(() => false);
}

function tapandaRefreshPopupGiftWrapState() {
  const giftWrapOffer = tapandaGetGiftWrapOffer();
  if (!giftWrapOffer) return;

  tapandaCheckGiftWrapInCart(giftWrapOffer.variantId).then((isInCart) => {
    tapandaSetPopupGiftWrapState(isInCart);
  });
}

function tapandaHandlePopupGiftWrapAdd(buttonNode) {
  if (!buttonNode || buttonNode.disabled) return;
  const variantId = String(buttonNode.dataset.variantId || '').trim();
  if (!variantId) return;

  tapandaRememberGiftWrapIntent(variantId);
  buttonNode.disabled = true;
  buttonNode.textContent = 'Dodawanie...';

  const cartUi = tapandaGetCartUiElement();
  addGiftWrapVariantToCart(variantId, cartUi, { source: 'popup_gift_wrap' })
    .then((response) => {
      if (!response || response.status) {
        throw new Error('gift-wrap-popup-add-failed');
      }

      if (cartUi && typeof cartUi.renderContents === 'function' && response.sections) {
        cartUi.renderContents(response);
      }

      tapandaSuppressExternalAtcNotice();
      tapandaClearGiftWrapIntent(variantId);
      tapandaSetPopupGiftWrapState(true);
      hideCartPromotionPopup();
      tapandaNavigateToCart('popup_gift_wrap_add');
    })
    .catch(() => {
      buttonNode.disabled = false;
      buttonNode.textContent = 'Dodaj opakowanie prezentowe';
    });
}

function showCartPromotionPopup(options = {}) {
  const popupOptions = (typeof options === 'boolean') ? { giftWrapSelected: options } : (options || {});
  const giftWrapSelected = !!popupOptions.giftWrapSelected;
  applySecondProductDiscountCode({ force: true });

  tapandaActivateCartRedirectGuard(TAPANDA_CART_REDIRECT_GUARD_DURATION_MS);
  tapandaWriteSessionNumber(TAPANDA_CART_PROMO_OPEN_UNTIL_KEY, Date.now() + TAPANDA_CART_REDIRECT_GUARD_MAX_MS);
  const popup = getCartPromotionPopup();
  document.body.classList.add('tp-cart-promo-open');
  tapandaSuppressExternalAtcNotice();
  if (giftWrapSelected) {
    tapandaSetPopupGiftWrapState(true);
  } else {
    tapandaRefreshPopupGiftWrapState();
  }
  popup.classList.add('is-visible');
  popup.setAttribute('aria-hidden', 'false');
  const closeButton = popup.querySelector('.tp-cart-promo-popup__close');
  if (closeButton && typeof closeButton.focus === 'function') {
    window.setTimeout(() => {
      try {
        closeButton.focus({ preventScroll: true });
      } catch (_error) {
        closeButton.focus();
      }
    }, 35);
  }
}

function hideCartPromotionPopup() {
  const popup = document.getElementById('tp-cart-promo-popup');
  if (!popup) return;
  popup.classList.remove('is-visible');
  popup.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('tp-cart-promo-open');
  tapandaWriteSessionNumber(TAPANDA_CART_PROMO_OPEN_UNTIL_KEY, 0);
  // Po zamknieciu popupu (X / overlay / Escape) wejscie do koszyka
  // musi byc natychmiast mozliwe — zdejmij guard.
  tapandaAllowCartNavigation(30000);
  stopCartPromotionCountdown();

}

function getCartPromotionPopup() {
  let popup = document.getElementById('tp-cart-promo-popup');
  if (popup) return popup;

  const discountCode = String(window.tapandaSecondProductDiscountCode || '').trim();
  const secondProductPath = String(
    window.tapandaCatalogPath ||
    window.tapandaSecondProductPath ||
    window.location.pathname ||
    '/collections/all'
  );
  const secondProductUrl = discountCode
    ? `/discount/${encodeURIComponent(discountCode)}?redirect=${encodeURIComponent(secondProductPath)}`
    : secondProductPath;

  const giftWrapOffer = tapandaGetGiftWrapOffer();

  // Karta opakowania prezentowego (jeśli oferta dostępna)
  let giftWrapCardHtml = '';
  if (giftWrapOffer) {
    const imageHtml = giftWrapOffer.image
      ? `<div class="tp-cart-promo-addon__media"><img src="${tapandaEscapeHtml(giftWrapOffer.image)}" alt="${tapandaEscapeHtml(giftWrapOffer.title)}" loading="lazy" width="72" height="72"></div>`
      : '';
    const priceHtml = giftWrapOffer.price
      ? `<p class="tp-cart-promo-addon__price">${tapandaEscapeHtml(giftWrapOffer.price)}</p>`
      : '';
    const addonClassName = imageHtml
      ? 'tp-cart-promo-addon'
      : 'tp-cart-promo-addon tp-cart-promo-addon--no-media';

    giftWrapCardHtml = `
        <div class="${addonClassName}">
          ${imageHtml}
          <div class="tp-cart-promo-addon__content">
            <div class="tp-cart-promo-addon__top">
              <p class="tp-cart-promo-addon__title">${tapandaEscapeHtml(giftWrapOffer.title)}</p>
              ${priceHtml}
            </div>
            <p class="tp-cart-promo-addon__desc">Zapewniamy staranne i estetyczne pakowanie.</p>
          </div>
          <div class="tp-cart-promo-addon__actions">
            <button type="button" class="tp-cart-promo-addon__btn" data-tp-popup-add-gift-wrap data-variant-id="${tapandaEscapeHtml(giftWrapOffer.variantId)}">
              Dodaj opakowanie prezentowe
            </button>
            <p class="tp-cart-promo-addon__note" data-tp-popup-gift-wrap-note hidden>Opakowanie prezentowe jest ju&#380; w koszyku.</p>
          </div>
        </div>
    `;
  }

  // Karta Piosenki AI — zawsze widoczna (link do kreatora; piosenka wymaga personalizacji, więc bez one-click add)
  const songLink = String(window.tapandaSongCtaLink || '/pages/kreator-piosenek');
  const songCardHtml = `
        <div class="tp-cart-promo-addon">
          <div class="tp-cart-promo-addon__media" style="display:grid;place-items:center;background:rgba(186,122,75,0.12);color:#ba7a4b;width:72px;height:72px;border-radius:12px;flex:0 0 72px;">
            <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/></svg>
          </div>
          <div class="tp-cart-promo-addon__content">
            <div class="tp-cart-promo-addon__top">
              <p class="tp-cart-promo-addon__title">Piosenka AI na tę okazję</p>
              <p class="tp-cart-promo-addon__price">od 9,99 zł</p>
            </div>
            <p class="tp-cart-promo-addon__desc">Spersonalizowany utwór — darmowa próbka 15 s.</p>
          </div>
          <div class="tp-cart-promo-addon__actions">
            <a class="tp-cart-promo-addon__btn" href="${tapandaEscapeHtml(songLink)}" style="text-decoration:none;display:inline-flex;align-items:center;justify-content:center;">Stwórz piosenkę</a>
          </div>
        </div>
  `;

  const giftWrapAddonHtml = `
      <div class="tp-cart-promo-popup__addons">
        <div class="tp-cart-promo-popup__addons-row">
          ${giftWrapCardHtml}
          ${songCardHtml}
        </div>
      </div>
  `;

  popup = document.createElement('div');
  popup.id = 'tp-cart-promo-popup';
  popup.className = 'tp-cart-promo-popup';
  popup.setAttribute('aria-hidden', 'true');
  popup.innerHTML = `
    <div class="tp-cart-promo-popup__overlay" data-tp-cart-promo-close></div>
    <div class="tp-cart-promo-popup__dialog" role="dialog" aria-modal="true" aria-label="Oferta specjalna">
      <button type="button" class="tp-cart-promo-popup__close" data-tp-cart-promo-close aria-label="Zamknij">&times;</button>
      <div class="tp-cart-promo-popup__status">
        <span class="tp-cart-promo-popup__status-icon">&#10003;</span>
        <span>Produkt został dodany do koszyka.</span>
      </div>
      <p class="tp-cart-promo-popup__message">Kup drugi produkt<span class="tp-cart-promo-popup__message-accent">30% taniej</span></p>
      <div class="tp-cart-promo-popup__actions">
        <a class="tp-cart-promo-popup__btn tp-cart-promo-popup__btn--tertiary" href="${secondProductUrl}">SKORZYSTAJ Z OFERTY</a>
      </div>
      ${giftWrapAddonHtml}
      <div class="tp-cart-promo-popup__actions">
        <button type="button" class="tp-cart-promo-popup__btn tp-cart-promo-popup__btn--primary" data-tp-popup-go-cart="true">PRZEJDŹ DO KOSZYKA</button>
      </div>
    </div>
  `;

  popup.addEventListener('click', (event) => {
    if (event.target.closest('[data-tp-cart-promo-close]')) {
      hideCartPromotionPopup();
      return;
    }

    const popupLink = event.target.closest('a[href]');
    if (popupLink) {
      // Linki w popupie (SKORZYSTAJ Z OFERTY / piosenka) nawiguja naturalnie —
      // bez preventDefault; chowamy popup i zdejmujemy guard, zeby po
      // przekierowaniu wejscie do koszyka bylo od razu mozliwe.
      hideCartPromotionPopup();
      return;
    }

    const goCartButton = event.target.closest('[data-tp-popup-go-cart]');
    if (goCartButton) {
      event.preventDefault();
      // Debounce 300 ms bez polykania — pierwszy klik zawsze dziala,
      // ignorujemy tylko duplikaty tuz po nim.
      const nowTs = Date.now();
      const lastGoCartClickAt = Number(popup.dataset.tpGoCartLastClickAt || 0);
      if (nowTs - lastGoCartClickAt < 300) {
        return;
      }
      popup.dataset.tpGoCartLastClickAt = String(nowTs);
      tapandaWriteSessionNumber(TAPANDA_CART_PROMO_OPEN_UNTIL_KEY, 0);
      tapandaAllowCartNavigation(45000);
      window.location.assign((window.routes && window.routes.cart_url) || '/cart');
      return;
    }

    const addGiftWrapButton = event.target.closest('[data-tp-popup-add-gift-wrap]');
    if (addGiftWrapButton) {
      event.preventDefault();
      tapandaHandlePopupGiftWrapAdd(addGiftWrapButton);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      hideCartPromotionPopup();
    }
  });

  document.body.appendChild(popup);
  return popup;
}

function applySecondProductDiscountCode(options = {}) {
  const forceApply = !!(options && options.force);
  const discountCode = String(window.tapandaSecondProductDiscountCode || '').trim();
  if (!discountCode || typeof document === 'undefined') return;

  // An activated, server-expiring offer must survive the second-print code.
  // The shared queue retains unrelated codes and never reloads the configurator.
  const retentionOffer = window.tapandaRetentionOffer;
  if (retentionOffer && retentionOffer.getSnapshot && retentionOffer.reconcileCart && retentionOffer.getSnapshot().code) {
    Promise.resolve(retentionOffer.reconcileCart({ extraCodes: [discountCode] })).catch(() => {});
    return;
  }

  const storageKey = `tp-discount-${discountCode.toUpperCase()}-applied-at`;
  const lockKey = `tp-discount-${discountCode.toUpperCase()}-inflight-until`;
  const now = Date.now();
  const retryCooldownMs = 45 * 1000;
  const lockDurationMs = 20 * 1000;

  try {
    const lockUntil = Number(sessionStorage.getItem(lockKey) || 0);
    if (!forceApply && lockUntil && now < lockUntil) return;

    const lastApplied = Number(sessionStorage.getItem(storageKey) || 0);
    if (!forceApply && lastApplied && now - lastApplied < retryCooldownMs) return;

    sessionStorage.setItem(lockKey, String(now + lockDurationMs));
  } catch (_error) {
    // no-op
  }

  let completed = false;
  const finalizeApply = (isSuccess) => {
    if (completed) return;
    completed = true;
    try {
      sessionStorage.removeItem(lockKey);
      if (isSuccess) {
        sessionStorage.setItem(storageKey, String(Date.now()));
      }
    } catch (_error) {
      // no-op
    }
  };

  const redirectTarget = `${window.location.pathname}${window.location.search || ''}`;
  const discountUrl = `/discount/${encodeURIComponent(discountCode)}?redirect=${encodeURIComponent(redirectTarget)}`;

  const applyByImage = () => {
    const beaconImage = new Image();
    beaconImage.decoding = 'async';
    beaconImage.referrerPolicy = 'same-origin';
    beaconImage.onload = () => finalizeApply(true);
    beaconImage.onerror = () => finalizeApply(false);
    beaconImage.src = `${discountUrl}&_=${Date.now()}`;
  };

  if (typeof fetch === 'function') {
    fetch(discountUrl, {
      method: 'GET',
      credentials: 'same-origin',
      redirect: 'follow',
      cache: 'no-store'
    })
      .then((response) => {
        if (response && response.ok) {
          finalizeApply(true);
          return;
        }
        applyByImage();
      })
      .catch(() => {
        applyByImage();
      });
    return;
  }

  applyByImage();
}

let tapandaActiveStylePopup = null;

function tapandaGetStylePopupFocusableNodes(containerNode) {
  if (!containerNode || !containerNode.querySelectorAll) return [];

  return Array.from(
    containerNode.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )
  ).filter((node) => {
    if (!node || node.getAttribute('aria-hidden') === 'true') return false;
    if (!node.getClientRects || node.getClientRects().length === 0) return false;
    const style = window.getComputedStyle ? window.getComputedStyle(node) : null;
    return !style || (style.visibility !== 'hidden' && style.display !== 'none');
  });
}

function showStylePickerPopup(triggerNode) {
  if (!triggerNode || !triggerNode.getAttribute) return;
  const targetSelector = triggerNode.getAttribute('data-tp-style-popup-target') || '';
  if (!targetSelector) return;

  const popup = document.querySelector(targetSelector);
  if (!popup) return;

  if (popup.parentElement !== document.body) {
    document.body.appendChild(popup);
  }

  if (tapandaActiveStylePopup && tapandaActiveStylePopup !== popup) {
    hideStylePickerPopup(tapandaActiveStylePopup, false);
  }

  popup.__tpStylePopupTrigger = triggerNode;
  triggerNode.setAttribute('aria-expanded', 'true');
  popup.hidden = false;
  popup.classList.add('is-visible');
  popup.setAttribute('aria-hidden', 'false');
  popup.setAttribute('data-portal-mounted', 'true');
  document.body.classList.add('tp-style-popup-open');
  document.documentElement.classList.add('tp-style-popup-open');
  tapandaActiveStylePopup = popup;

  const closeButton = popup.querySelector('[data-tp-style-popup-close-button]');
  if (closeButton && typeof closeButton.focus === 'function') {
    window.setTimeout(() => {
      try {
        closeButton.focus({ preventScroll: true });
      } catch (_error) {
        closeButton.focus();
      }
    }, 30);
  }
}

function hideStylePickerPopup(popupNode, shouldReturnFocus = true) {
  const popup = popupNode || tapandaActiveStylePopup || document.querySelector('.tp-style-popup.is-visible');
  if (!popup) return;

  const triggerNode = popup.__tpStylePopupTrigger;

  popup.classList.remove('is-visible');
  popup.setAttribute('aria-hidden', 'true');
  popup.hidden = true;
  popup.__tpStylePopupTrigger = null;

  if (triggerNode && triggerNode.setAttribute) {
    triggerNode.setAttribute('aria-expanded', 'false');
  }

  if (tapandaActiveStylePopup === popup) {
    tapandaActiveStylePopup = null;
  }
  document.body.classList.remove('tp-style-popup-open');
  document.documentElement.classList.remove('tp-style-popup-open');

  if (shouldReturnFocus && triggerNode && triggerNode.isConnected && typeof triggerNode.focus === 'function') {
    window.requestAnimationFrame(() => {
      try {
        triggerNode.focus({ preventScroll: true });
      } catch (_error) {
        triggerNode.focus();
      }
    });
  }
}

function tapandaBindStylePickerPopup() {
  if (window.__tpStylePickerPopupBound) return;
  window.__tpStylePickerPopupBound = true;

  document.addEventListener('click', (event) => {
    const openButton = event.target && event.target.closest ? event.target.closest('[data-tp-style-popup-open]') : null;
    if (openButton) {
      event.preventDefault();
      showStylePickerPopup(openButton);
      return;
    }

    const visiblePopup = tapandaActiveStylePopup || document.querySelector('.tp-style-popup.is-visible');
    if (visiblePopup && visiblePopup.classList.contains('is-visible')) {
      const dialog = visiblePopup.querySelector('.tp-style-popup__dialog');
      if (dialog && !dialog.contains(event.target)) {
        event.preventDefault();
        hideStylePickerPopup(visiblePopup);
        return;
      }
    }

    const closeTrigger = event.target && event.target.closest ? event.target.closest('[data-tp-style-popup-close]') : null;
    if (!closeTrigger) return;
    event.preventDefault();
    const popup = closeTrigger.closest ? closeTrigger.closest('.tp-style-popup') : null;
    hideStylePickerPopup(popup || null);
  });

  document.addEventListener('keydown', (event) => {
    const visiblePopup = tapandaActiveStylePopup || document.querySelector('.tp-style-popup.is-visible');
    if (!visiblePopup || !visiblePopup.classList.contains('is-visible')) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      hideStylePickerPopup(visiblePopup);
      return;
    }

    if (event.key !== 'Tab') return;
    const dialog = visiblePopup.querySelector('.tp-style-popup__dialog');
    const focusableNodes = tapandaGetStylePopupFocusableNodes(dialog);
    if (!focusableNodes.length) return;

    const firstNode = focusableNodes[0];
    const lastNode = focusableNodes[focusableNodes.length - 1];
    const activeNode = document.activeElement;

    if (!dialog.contains(activeNode)) {
      event.preventDefault();
      firstNode.focus();
      return;
    }

    if (event.shiftKey && activeNode === firstNode) {
      event.preventDefault();
      lastNode.focus();
    } else if (!event.shiftKey && activeNode === lastNode) {
      event.preventDefault();
      firstNode.focus();
    }
  });
}

function formatSecondsToMMSS(totalSeconds) {
  const safe = Math.max(0, Number(totalSeconds) || 0);
  const minutes = Math.floor(safe / 60);
  const seconds = safe % 60;
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}

function stopCartPromotionCountdown() {
  if (window.__tpCartPromoTimerId) {
    clearInterval(window.__tpCartPromoTimerId);
    window.__tpCartPromoTimerId = null;
  }
}

function startCartPromotionCountdown(durationSeconds) {
  stopCartPromotionCountdown();
  const valueNode = document.getElementById('tp-cart-promo-countdown-value');
  if (!valueNode) return;

  const endAt = Date.now() + (Number(durationSeconds) || 0) * 1000;
  window.__tpCartPromoTimerId = setInterval(() => {
    const remaining = Math.max(0, Math.ceil((endAt - Date.now()) / 1000));
    valueNode.textContent = formatSecondsToMMSS(remaining);
    if (remaining <= 0) {
      stopCartPromotionCountdown();
    }
  }, 1000);

  valueNode.textContent = formatSecondsToMMSS(durationSeconds);
}

function tapandaIsCartUrl(urlCandidate) {
  try {
    const parsed = new URL(urlCandidate, window.location.origin);
    const normalizePath = (value) => {
      const raw = String(value || '');
      const withoutQuery = raw.split('?')[0].split('#')[0];
      const trimmed = withoutQuery.replace(/\/+$/, '');
      return trimmed || '/';
    };
    const isCartPath = (pathValue) => {
      const cartPathLocal = normalizePath(window.routes?.cart_url || '/cart');
      const candidatePath = normalizePath(pathValue);
      if (candidatePath === cartPathLocal || candidatePath === '/cart') return true;
      if (/^\/cart(\/|$)/.test(candidatePath)) return true;
      if (cartPathLocal !== '/cart' && candidatePath.indexOf(`${cartPathLocal}/`) === 0) return true;
      return false;
    };
    const resolveRedirectPath = (redirectValue) => {
      if (!redirectValue) return '';
      const decoded = (() => {
        try {
          return decodeURIComponent(String(redirectValue));
        } catch (_error) {
          return String(redirectValue);
        }
      })();
      try {
        return normalizePath(new URL(decoded, window.location.origin).pathname);
      } catch (_error) {
        return normalizePath(decoded);
      }
    };

    const cartPath = normalizePath(window.routes?.cart_url || '/cart');
    const currentPath = normalizePath(parsed.pathname);
    if (isCartPath(currentPath)) return true;

    if (/^\/discount(\/|$)/.test(currentPath)) {
      const redirectCandidate =
        parsed.searchParams.get('redirect') ||
        parsed.searchParams.get('return_to') ||
        parsed.searchParams.get('target') ||
        '';
      const redirectedPath = resolveRedirectPath(redirectCandidate);
      if (redirectedPath && isCartPath(redirectedPath)) return true;
    }

    if (cartPath !== '/cart' && currentPath.indexOf(`${cartPath}/`) === 0) return true;
    return false;
  } catch (_error) {
    return false;
  }
}

function tapandaActivateCartRedirectGuard(durationMs) {
  // Jedyna implementacja guardu (ciche tlumienie PROGRAMOWYCH
  // location.assign/replace do /cart) mieszka w layout/theme.liquid —
  // tu tylko ustawiamy okno czasowe guardu (max 5 s).
  const duration = Math.min(
    TAPANDA_CART_REDIRECT_GUARD_MAX_MS,
    Math.max(1000, Number(durationMs) || TAPANDA_CART_REDIRECT_GUARD_DURATION_MS)
  );
  const guardUntil = Date.now() + duration;
  window.__tpBlockCartNavigationUntil = guardUntil;
  tapandaWriteSessionNumber(TAPANDA_CART_REDIRECT_GUARD_UNTIL_KEY, guardUntil);
  tapandaWriteSessionNumber(TAPANDA_CART_REDIRECT_ALLOW_UNTIL_KEY, 0);
  tapandaRememberCartReturnUrl();
}

function tapandaBindTeeinblueGlobalGuard() {
  if (window.__tpTeeinblueGlobalGuardBound) return;
  window.__tpTeeinblueGlobalGuardBound = true;

  const teeinblueButtonSelector = '#teeAtcButton, .tee-btn--atc, #teeFormActions button[type="submit"], .tee-form-actions button[type="submit"]';

  const looksLikeTeeinblueForm = (formNode) => {
    if (!formNode || !formNode.matches) return false;
    if (formNode.matches('.tee-customize-main-form, form.tee-form-wrapper')) return true;
    if (formNode.querySelector && formNode.querySelector('#teeAtcButton, .tee-btn--atc, #teeFormActions, .tee-form-actions, [data-teeinblue], [class*="teeinblue"]')) return true;
    if (formNode.dataset && (formNode.dataset.teeinblue || formNode.dataset.teeInBlue)) return true;
    return false;
  };

  const activateGuard = () => {
    tapandaActivateCartRedirectGuard(TAPANDA_CART_REDIRECT_GUARD_DURATION_MS);
    applySecondProductDiscountCode();
    if (typeof tapandaSuppressExternalAtcNotice === 'function') {
      tapandaSuppressExternalAtcNotice();
    }
  };

  document.addEventListener('click', (event) => {
    const buttonNode = event.target && event.target.closest ? event.target.closest(teeinblueButtonSelector) : null;
    if (!buttonNode) return;
    activateGuard();
  }, true);

  ['pointerdown', 'mousedown', 'touchstart'].forEach((eventName) => {
    document.addEventListener(eventName, (event) => {
      const actionsNode = event.target && event.target.closest ? event.target.closest('#teeFormActions, .tee-form-actions') : null;
      if (!actionsNode) return;
      activateGuard();
    }, true);
  });

  document.addEventListener('submit', (event) => {
    const formNode = event.target;
    if (!looksLikeTeeinblueForm(formNode)) return;
    activateGuard();
  }, true);

  if (window.MutationObserver && !window.__tpTeeinblueAtcObserverBound) {
    window.__tpTeeinblueAtcObserverBound = true;

    const normalizeStatusText = (value) => String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();

    const statusTokens = ['dodano do koszyka', 'ten przedmiot zostal dodany', 'added to cart'];

    const observer = new MutationObserver((mutationsList) => {
      for (let i = 0; i < mutationsList.length; i += 1) {
        const targetNode = mutationsList[i].target;
        if (!targetNode || targetNode.nodeType !== 1) continue;
        if (!targetNode.closest || !targetNode.closest('#teeFormActions, .tee-form-actions, .tp-tee-atc-success')) continue;

        const statusText = normalizeStatusText(targetNode.textContent || '');
        if (!statusText) continue;

        for (let t = 0; t < statusTokens.length; t += 1) {
          if (statusText.indexOf(statusTokens[t]) !== -1) {
            activateGuard();
            if (typeof showCartPromotionPopup === 'function') {
              showCartPromotionPopup();
            }
            return;
          }
        }
      }
    });

    try {
      observer.observe(document.documentElement || document.body, {
        subtree: true,
        childList: true
      });
    } catch (_error) {
      // no-op
    }

    // Teeinblue exposes Shopify.onItemAdded
    window.Shopify = window.Shopify || {};
    const originalOnItemAdded = window.Shopify.onItemAdded;
    window.Shopify.onItemAdded = function(line_item) {
      if (typeof originalOnItemAdded === 'function') {
        try { originalOnItemAdded(line_item); } catch (e) {}
      }
      activateGuard();
      if (typeof showCartPromotionPopup === 'function') {
        showCartPromotionPopup();
      }
    };
  }
}

window.tapandaActivateCartRedirectGuard = tapandaActivateCartRedirectGuard;
window.tapandaShowCartPromotionPopup = showCartPromotionPopup;
window.tapandaHideCartPromotionPopup = hideCartPromotionPopup;
window.tapandaRememberGiftWrapIntent = tapandaRememberGiftWrapIntent;
window.tapandaReadGiftWrapIntent = tapandaReadGiftWrapIntent;
window.tapandaClearGiftWrapIntent = tapandaClearGiftWrapIntent;
window.tapandaSuppressExternalAtcNotice = tapandaSuppressExternalAtcNotice;
window.tapandaApplySecondProductDiscountCode = applySecondProductDiscountCode;
window.tapandaAllowCartNavigation = tapandaAllowCartNavigation;
window.tapandaNavigateToCart = tapandaNavigateToCart;
tapandaHydrateCartRedirectGuard();
tapandaRecoverFromUnexpectedCartRedirect();
tapandaBindTeeinblueGlobalGuard();
tapandaBindStylePickerPopup();
